import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  className?: string;
}
export function CountdownTimer({
  className = ''
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 53,
    seconds: 10
  });
  useEffect(() => {
    const savedEndTime = localStorage.getItem('kitProgEndTime');
    let endTime: number;
    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10);
      if (Date.now() > endTime) {
        endTime = Date.now() + 23 * 60 * 60 * 1000 + 53 * 60 * 1000 + 10 * 1000;
        localStorage.setItem('kitProgEndTime', endTime.toString());
      }
    } else {
      endTime = Date.now() + 23 * 60 * 60 * 1000 + 53 * 60 * 1000 + 10 * 1000;
      localStorage.setItem('kitProgEndTime', endTime.toString());
    }
    const interval = setInterval(() => {
      const difference = endTime - Date.now();
      if (difference <= 0) {
        const newEnd = Date.now() + 23 * 60 * 60 * 1000 + 53 * 60 * 1000 + 10 * 1000;
        localStorage.setItem('kitProgEndTime', newEnd.toString());
        return;
      }
      setTimeLeft({
        hours: Math.floor(difference / (1000 * 60 * 60) % 24),
        minutes: Math.floor(difference / 1000 / 60 % 60),
        seconds: Math.floor(difference / 1000 % 60)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <div className={`flex items-center justify-center space-x-1 font-montserrat font-semibold text-lg md:text-2xl ${className}`} data-id="element-39">
      <div className="px-1.5 py-0.5 rounded-lg border border-current/30 flex flex-col items-center" data-id="element-40">
        <span data-id="element-41">{fmt(timeLeft.hours)}</span>
        <span className="text-[8px] opacity-60 font-sans font-normal" data-id="element-42">
          horas
        </span>
      </div>
      <span className="animate-pulse pb-2 opacity-60" data-id="element-43">:</span>
      <div className="px-1.5 py-0.5 rounded-lg border border-current/30 flex flex-col items-center" data-id="element-44">
        <span data-id="element-45">{fmt(timeLeft.minutes)}</span>
        <span className="text-[8px] opacity-60 font-sans font-normal" data-id="element-46">min</span>
      </div>
      <span className="animate-pulse pb-2 opacity-60" data-id="element-47">:</span>
      <div className="px-1.5 py-0.5 rounded-lg border border-current/30 flex flex-col items-center" data-id="element-48">
        <span data-id="element-49">{fmt(timeLeft.seconds)}</span>
        <span className="text-[8px] opacity-60 font-sans font-normal" data-id="element-50">seg</span>
      </div>
    </div>;
}